import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'relativeDate' })
export class RelativeDatePipe implements PipeTransform {
  transform(value: string | Date | number | null | undefined): string {
    if (!value) return '';
    const date = new Date(value);
    const now = new Date();
    const diff = +now - +date; // ms
    const abs = Math.abs(diff);
    const minute = 60_000;
    const hour = 60 * minute;
    const day = 24 * hour;
    const month = 30 * day;
    if (abs < minute) return diff >= 0 ? 'just now' : 'in a few seconds';
    if (abs < hour) {
      const m = Math.round(abs / minute);
      return diff >= 0 ? `${m} minute${m>1?'s':''} ago` : `in ${m} minute${m>1?'s':''}`;
    }
    if (abs < day) {
      const h = Math.round(abs / hour);
      return diff >= 0 ? `${h} hour${h>1?'s':''} ago` : `in ${h} hour${h>1?'s':''}`;
    }
    if (abs < month) {
      const d = Math.round(abs / day);
      return diff >= 0 ? `${d} day${d>1?'s':''} ago` : `in ${d} day${d>1?'s':''}`;
    }
    return date.toLocaleDateString();
  }
}

//Usage: {{ investor.createdAt | relativeDate }}
